import TrackingDataHelper from './trackingDataHelper.js';

class Device {
  getDeviceData() {
    const deviceData = {};
    deviceData.cookie = this.getCookieData();
    deviceData.sess_cookie = this.getSessCookieData();
    deviceData.user_agent = this.getUserAgent();
    deviceData.type = this.getType();
    deviceData.screen = this.getScreenData();
    deviceData.browser = this.getBrowserData();
    
    const ipData = this.getIpData();
    if (ipData) {
      deviceData.ip = ipData;
    }
    
    return {
      device: deviceData,
    };
  }
  
  getUserAgent() {
    return this.getTrackingDataHelper().getUserAgent();
  }
  
  getCookieData() {
    return this.getTrackingDataHelper().getCookie();
  }
  
  getSessCookieData() {
    return this.getTrackingDataHelper().getSessCookie();
  }
  
  getType() {
    return this.getTrackingDataHelper().getDeviceInfo(navigator.userAgent);
  }
  
  getScreenData() {
    const screenData = {};
    screenData.width = window.screen.width;
    screenData.height = window.screen.height;
    if (window.devicePixelRatio) {
      screenData.pixel_ratio = window.devicePixelRatio;
    }
    return screenData;
  }
  
  getBrowserData() {
    const browserData = {};
    browserData.family = this.getTrackingDataHelper().getBrowserData('name');
    browserData.version = this.getTrackingDataHelper().getBrowserData('version');
    browserData.major_version = this.getTrackingDataHelper().getBrowserData('major');
    return browserData;
  }
  
  getIpData() {
    const ip = this.getTrackingDataHelper().getSiteObjectData('visitorNetworkIdentifier');
    if (ip) {
      return {
        sha256_ip_hash: ip,
      };
    }
  }
  
  getTrackingDataHelper() {
    return TrackingDataHelper;
  }
}

export default new Device();
